export default "__VITE_ASSET__DHXX76GS__"